import { SETUP_MODULES } from "config/setupModules";
import { isSuperuserUser } from "utils/dashboardScope";

export function canAccessSetupModule(moduleSlug, user) {
  void moduleSlug;
  return isSuperuserUser(user);
}

export function getAllowedSetupModules(user) {
  return SETUP_MODULES.filter((moduleConfig) => canAccessSetupModule(moduleConfig.slug, user));
}

export function getDefaultAllowedSetupModuleSlug(user) {
  return getAllowedSetupModules(user)[0]?.slug || null;
}
